module.exports = __webpack_public_path__ + "rippling.f49ec7.svg";